module.exports = __webpack_public_path__ + "static/media/EX_FINISHED_alt_8.77475311.mp3";